import { createContext } from "react";

export interface IBattleContext {
  isFirstTurn: boolean;
  autoBattle: boolean;
  setAutoBattle: React.Dispatch<React.SetStateAction<boolean>>;
}

const BattleContext = createContext<IBattleContext>({
  isFirstTurn: true,
  autoBattle: false,
  setAutoBattle: () => {}
});

export default BattleContext;
